import { Reducer } from "redux";

import { DocumentFileResponse } from "../models/Api/Document";
import { ReferralDocumentFileActionDispatchTypes } from "../models/DispatchTypes/Document";
import { ReferralDocumentFileDispatchTypes } from "../constants/Document";

const initialState: DocumentFileResponse = {
  loading: false,
  response: {
    totalRows: 0,
    blobDocumentList: [],
    searchDocumentRecordGet: {
      referralId: -1,
      type: -1,
      pageNo: -1,
      pageSize: -1,
      documentDateTime: {
        dateType: "",
        firstDateTime: "",
        secondDateTime: "",
        utcOffsetValue: 0,
      },
      documentCreatedBy: [],
      documentFaxStatus: [],
      documentSource: [],
      documentType: [],
    },
  },
  error: null,
};

const SaveOrUpdateDocumentFile: Reducer<
  DocumentFileResponse,
  ReferralDocumentFileActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveOrUpdateDocumentFile;
